import { ExclamationCircleFilled } from "@ant-design/icons";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import MenuIcon from "@mui/icons-material/Menu";
import {
  AppBar,
  Avatar,
  Box,
  Button,
  ClickAwayListener,
  Collapse,
  Container,
  CssBaseline,
  Drawer,
  IconButton,
  List,
  ListItemButton,
  Menu,
  MenuItem,
  Paper,
  Popper,
  Toolbar,
  Typography,
} from "@mui/material";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { ArrowDropDownIcon, ArrowRightIcon } from "@mui/x-date-pickers";
import { Form, Modal } from "antd";
import { get, post, put } from "api/base";
import { API, Auth } from "aws-amplify";
import FormRegister from "components/form-register";
import ModalChangePassword from "components/modal-change-pw";
import Spinner from "components/spinner";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import {
  CHANGE_PASSWORD_ERROR_TYPE,
  FORM_TYPE,
  LOCAL_STORAGE_KEY,
  NOTIFICATION_TYPE,
  USER_GROUP,
} from "constants/common.constant";
import { ROUTERS } from "constants/routes.constant";
import { customContext } from "hook/context";
import { TypeCommon } from "models/common";
import React, { ReactElement, useContext, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import { BiVector } from "react-icons/bi";
import { FaBell, FaUsers } from "react-icons/fa";
import { MdMiscellaneousServices } from "react-icons/md";
import { useMediaQuery } from "react-responsive";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";
import {
  ToastMessage,
  getIdTokenFromLocalStorage,
  isJsonObject,
  removeLocalDataIgnoreKey,
} from "utils/common.util";
import logo from "../../assets/logo_1.png";
import "./index.css";
import { Button as ButtonAntd } from "antd";
// import uat from "../../assets/uat.png";

const MainLayout = (): ReactElement => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { listOrg, getList, userServices, getUserDetail, resetUser } =
    useContext(customContext);
  const isMobile = useMediaQuery({ query: "(max-width: 1200px)" });
  const location = useLocation().pathname;

  // Detect if device is mobile (phone/tablet) or desktop/laptop
  const isMobileDevice = (): boolean => {
    const userAgent = navigator.userAgent.toLowerCase();
    return (
      /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
        userAgent,
      ) || window.innerWidth <= 768
    );
  };
  const [form] = Form.useForm<TypeCommon>();
  const [formUpdate] = Form.useForm<TypeCommon>();
  const [formPreview] = Form.useForm<TypeCommon>();
  const userInfo =
    isJsonObject(localStorage.getItem(LOCAL_STORAGE_KEY.USER_INFO)) &&
    JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY.USER_INFO) as string);
  const redirect = localStorage.getItem(LOCAL_STORAGE_KEY.REDIRECT);
  const [isEmailExist, setIsEmailExist] = useState<boolean>(false);

  const muiMenuItems: MenuItemType[] = [
    {
      key: ROUTERS.USER_MANAGEMENT,
      icon: <FaUsers />,
      label: t("dashboard.button2"),
      path: ROUTERS.USER_MANAGEMENT,
    },
    {
      key: ROUTERS.SERVICE_MANAGEMENT,
      icon: <MdMiscellaneousServices />,
      label: "サービス管理",
      path: ROUTERS.SERVICE_MANAGEMENT,
    },
    {
      key: ROUTERS.ORGANIZATION_LIST,
      icon: <BiVector />,
      label: "組織管理",
      path: ROUTERS.ORGANIZATION_LIST,
      disabled:
        userInfo?.group !== USER_GROUP.PLATFORM_ADMIN &&
        userInfo?.group !== USER_GROUP.ADMIN,
    },
    {
      key: ROUTERS.NOTIFICATION_SETTING,
      icon: <FaBell />,
      label: "通知設定",
      path: ROUTERS.NOTIFICATION_SETTING,
      disabled:
        userInfo?.group !== USER_GROUP.PLATFORM_ADMIN &&
        userInfo?.group !== USER_GROUP.ADMIN,
    },
  ];

  const menuItems = [
    {
      key: ROUTERS.USER_MANAGEMENT,
      label: (
        <Link className="link flex items-center" to={ROUTERS.USER_MANAGEMENT}>
          <FaUsers className="text-[20px] mr-2" />
          {t("dashboard.button2")}
        </Link>
      ),
    },
    {
      key: ROUTERS.SERVICE_MANAGEMENT,
      label: (
        <Link
          className="link flex items-center"
          to={ROUTERS.SERVICE_MANAGEMENT}
        >
          <MdMiscellaneousServices className="text-[20px] mr-2" />
          サービス管理
        </Link>
      ),
    },
    {
      key: ROUTERS.ORGANIZATION_LIST,
      label: (
        <Link className="link flex items-center" to={ROUTERS.ORGANIZATION_LIST}>
          <BiVector className="text-[20px] mr-2" />
          組織管理
        </Link>
      ),
      disabled: !(
        userInfo?.group === USER_GROUP.PLATFORM_ADMIN ||
        userInfo?.group === USER_GROUP.ADMIN ||
        localStorage.getItem(LOCAL_STORAGE_KEY.LOGIN_DEVICE) === "azure"
      ),
    },
    {
      key: ROUTERS.NOTIFICATION_SETTING,
      label: (
        <Link
          className="link flex items-center"
          to={ROUTERS.NOTIFICATION_SETTING}
        >
          <FaBell className="text-[20px] mr-2" />
          通知設定
        </Link>
      ),
      disabled:
        userInfo?.group !== USER_GROUP.PLATFORM_ADMIN &&
        userInfo?.group !== USER_GROUP.ADMIN,
    },
  ];
  const [menuList, setMenuList] = useState<TypeCommon>(menuItems);
  const [menuListMui, setMenuListMui] = useState<MenuItemType[]>(muiMenuItems);

  const [isExpired, setIsExpired] = useState<boolean>(false);
  const [serviceIds, setServiceIds] = useState<TypeCommon>([
    ROUTERS.SERVICE_MANAGEMENT,
  ]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isFetchDetail, setIsFetchDetail] = useState<boolean>(false);
  const [isOpenModalChangePw, setIsOpenModalChangePw] =
    useState<boolean>(false);
  const [currentUser, setCurrentUser] = useState<TypeCommon>();
  const [listOrgs, setListOrgs] = useState<TypeCommon>([]);
  const [isOpenModalPreview, setIsOpenModalPreview] = useState<boolean>(false);
  const [isOpenModalUpdateUser, setIsOpenModalUpdateUser] =
    useState<boolean>(false);
  const getWindowDimensions = (): TypeCommon => {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  };
  const [windowDimensions, setWindowDimensions] = useState<TypeCommon>(
    getWindowDimensions(),
  );

  const confirm = (): TypeCommon => {
    Modal.info({
      title: t("button.confirm"),
      content: "1時間以上操作しないので自動的にログアウトされました。",
      okText: t("button.confirm"),
      onOk() {
        logout();
      },
      centered: true,
      closable: false,
    });
  };

  const confirmLogout = (): TypeCommon => {
    Modal.confirm({
      title: t("button.confirm"),
      icon: <ExclamationCircleFilled className="!text-[#1677ff]" />,
      content: "ログアウトしても宜しいでしょうか。",
      okText: t("button.yes"),
      cancelText: t("button.no"),
      onOk() {
        logout();
      },
      centered: true,
      closable: false,
      okButtonProps: {
        className: "!min-w-[75px] !mr-2",
      },
      cancelButtonProps: {
        className: "!min-w-[75px]",
      },
    });
  };
  useEffect(() => {
    if (
      location !== ROUTERS.APPROVE &&
      location !== ROUTERS.DETAIL_FORM &&
      location !== ROUTERS.SUPPERLIER_SCREEN_INPUT_FORM &&
      location !== ROUTERS.PHOTOGRAPHING_DOCUMENT
    ) {
      sessionStorage.removeItem(LOCAL_STORAGE_KEY.SEARCH_CONDITIONS);
    }
    if (location === ROUTERS.SERVICE_MANAGEMENT) {
      getUserDetail();
    }
  }, [location]);
  const fetchUserDetailData = async (): Promise<void> => {
    try {
      setIsFetchDetail(true);
      const serviceList: TypeCommon = [];
      const serviceListMui: MenuItemType[] = [];
      let isForm = false;
      // let serviceFormId = "";
      // let serviceTokubaiId = "";
      if (userServices?.length > 0) {
        const ownerIds: string[] = [];
        userServices?.forEach((item: TypeCommon, index: number) => {
          if (item?.is_active) {
            //koji
            if (item?.type === "form") {
              isForm = true;
              // serviceFormId = item?.id;
            }
            ownerIds?.push(item?.id);

            serviceListMui.push({
              key: item?.url,
              label: item?.name,
              path: item?.url,
              is_release: item?.release_status,
              serviceid: item?.id,
              type: item?.type,
              parent: ROUTERS.SERVICE_MANAGEMENT,
              is_summit_service: item?.is_summit_service,
              is_active: item?.is_active,
            });

            serviceList.push({
              key: `${item?.url}?index=${index}`,
              label: (
                <Link
                  className="link flex items-center"
                  target={`${item?.type === "form" ? "" : "_blank"}`}
                  to={item?.url}
                  onClick={(e) => {
                    e.preventDefault();
                    if ("Notification" in window) {
                      localStorage.setItem(
                        LOCAL_STORAGE_KEY.NOTIFICATION_PERMISIION,
                        Notification?.permission,
                      );
                    }
                    if (item?.type !== "form") {
                      setTimeout(() => {
                        if (isMobileDevice()) {
                          window.location.assign(item?.url);
                        } else {
                          window.open(item?.url, "_blank");
                        }
                      }, 100);
                    } else {
                      navigate(item?.url);
                    }
                  }}
                >
                  {!item?.release_status && (
                    <span className="text-white !text-[12.5px] mr-2 bg-[#fadb14] !px-[8px] !rounded !h-[20px] flex items-center justify-center">
                      UAT
                    </span>
                  )}
                  <span className="truncate max-w-full">{item?.name}</span>
                </Link>
              ),
              serviceid: item?.id,
              release_status: item?.release_status,
            });
          }
        });

        setServiceIds(ownerIds);
        // Check if userInfo.name matches pattern: starts with 't' followed by number > 100
        const isValidUserName =
          userInfo?.username &&
          /^s\d+$/.test(userInfo.username) &&
          Number.parseInt(userInfo.username.substring(1), 10) > 100;

        if (
          isForm &&
          !redirect &&
          location === ROUTERS.SERVICE_MANAGEMENT &&
          // !userInfo?.is_tokubai &&
          userInfo?.group !== USER_GROUP.PLATFORM_ADMIN &&
          isValidUserName
        ) {
          navigate(ROUTERS.APPROVE);
          localStorage.setItem(LOCAL_STORAGE_KEY.REDIRECT, isForm);
        }

        serviceList.sort((a: TypeCommon, b: TypeCommon) => {
          if (a.release_status !== b.release_status) {
            return Number(b.release_status) - Number(a.release_status);
          }
          if (a.release_status === true) {
            return a.serviceid - b.serviceid;
          }
          return 0;
        });

        const listChilren = [...serviceList];
        const index = menuList.findIndex(
          (el: TypeCommon) => el.key === ROUTERS.SERVICE_MANAGEMENT,
        );
        if (index > -1) {
          menuList[index] = {
            key: ROUTERS.SERVICE_MANAGEMENT,
            label: (
              <Link
                className="link flex items-center"
                to={ROUTERS.SERVICE_MANAGEMENT}
              >
                <MdMiscellaneousServices className="text-[20px] mr-2" />
                サービス管理
              </Link>
            ),
            children: listChilren?.length > 0 ? listChilren : false,
          };
          setMenuList([...menuList]);
        }

        // set menu mui
        const targetItem = menuListMui.find(
          (item) => item.path === ROUTERS.SERVICE_MANAGEMENT,
        );

        // Sort serviceListMui by is_release status
        const sortedServiceListMui = serviceListMui.sort(
          (a: MenuItemType, b: MenuItemType) => {
            // First sort by release_status
            if (a.is_release !== b.is_release) {
              return Number(b.is_release) - Number(a.is_release);
            }
            // Then sort by serviceid for all items
            return (a.serviceid || 0) - (b.serviceid || 0);
          },
        );

        if (targetItem) {
          targetItem.children = sortedServiceListMui;
        }
        setMenuListMui([...menuListMui]);
      } else {
        setServiceIds([]);
      }
      setIsFetchDetail(false);
    } catch (error: TypeCommon) {
      setIsFetchDetail(false);
      ToastMessage(NOTIFICATION_TYPE.ERROR, t("alert-message.failure"));
    }
  };
  useEffect(() => {
    fetchUserDetailData();
  }, [userServices]);
  const logout = async (): Promise<void> => {
    try {
      await Auth.signOut();
      removeLocalDataIgnoreKey([LOCAL_STORAGE_KEY.LIST_USER]);
      sessionStorage.clear();
      resetUser();
      navigate(ROUTERS.LOGIN);
    } catch (error) {
      ToastMessage(NOTIFICATION_TYPE.ERROR, t("alert-message.failure"));
    }
  };
  const getNewRefreshToken = async (): Promise<void> => {
    try {
      const res = await get("login", "/login/refresh", {
        username: userInfo?.username,
      });

      // Cập nhật refresh_token vào localStorage của Cognito
      const CLIENT_ID = "ke60sjpuo295i99e9j2n594q0";
      const USERNAME = res?.username || userInfo?.username;
      if (res?.refresh_token && USERNAME) {
        localStorage.setItem(
          `CognitoIdentityServiceProvider.${CLIENT_ID}.${USERNAME}.refreshToken`,
          res.refresh_token,
        );
      }

      localStorage.setItem(LOCAL_STORAGE_KEY.REFRESH_TOKEN, res.refresh_token);

      const issuedAt = Date.now();
      const expiresAt = issuedAt + 30 * 24 * 60 * 60 * 1000; // Cognito default = 30 ngày
      localStorage.setItem(
        LOCAL_STORAGE_KEY.REFRESH_EXPIRES_AT,
        expiresAt.toString(),
      );
    } catch (error: TypeCommon) {
      setIsLoading(false);
      ToastMessage(NOTIFICATION_TYPE.ERROR, t("alert-message.failure"));
    }
  };
  const checkRefreshToken = (): void => {
    const expiresAtStr = localStorage.getItem(
      LOCAL_STORAGE_KEY.REFRESH_EXPIRES_AT,
    );
    const expiresAt = expiresAtStr ? parseInt(expiresAtStr, 10) : 0;
    const now = Date.now();

    const ONE_DAY = 24 * 60 * 60 * 1000;

    if (expiresAt - now < ONE_DAY) {
      getNewRefreshToken();
    }
  };
  useEffect(() => {
    const isAzure =
      localStorage.getItem(LOCAL_STORAGE_KEY.LOGIN_DEVICE) === "azure";
    if (isAzure) checkRefreshToken();
  }, []);
  const checkForInactivity = (): void => {
    const expireTime: TypeCommon = localStorage.getItem(
      LOCAL_STORAGE_KEY.EXPIRE_TIME,
    );
    if (expireTime && expireTime < Date.now()) {
      setIsExpired(true);
    }
  };
  const updateExpireTime = (): void => {
    const isAzure =
      localStorage.getItem(LOCAL_STORAGE_KEY.LOGIN_DEVICE) === "azure";
    const expireTime: TypeCommon = isAzure
      ? Date.now() + 30 * 24 * 60 * 60 * 1000
      : Date.now() + 3600000;
    localStorage.setItem(LOCAL_STORAGE_KEY.EXPIRE_TIME, expireTime);
  };
  const saveExpireTime = (): void => {
    const expireTime: TypeCommon = localStorage.getItem(
      LOCAL_STORAGE_KEY.EXPIRE_TIME,
    );
    localStorage.setItem(LOCAL_STORAGE_KEY.LAST_EXPIRE_TIME, expireTime);
  };
  const handleClickUpdateInfo = async (): Promise<void> => {
    setCurrentUser(userInfo);
    setIsOpenModalUpdateUser(true);
  };

  // const getRefreshToken = async (): Promise<TypeCommon> => {
  //   try {
  //     const session = await Auth.currentSession();
  //     const refreshToken = session.getRefreshToken().getToken();
  //     const currentToken = localStorage.getItem(
  //       LOCAL_STORAGE_KEY.REFRESH_TOKEN,
  //     );
  //     if (refreshToken !== currentToken) {
  //       localStorage.setItem(LOCAL_STORAGE_KEY.REFRESH_TOKEN, refreshToken);
  //     }
  //   } catch (err) {
  //     return "";
  //   }
  // };
  // useEffect(() => {
  //   getRefreshToken();
  // }, []);
  useEffect(() => {
    if (isExpired) {
      removeLocalDataIgnoreKey([LOCAL_STORAGE_KEY.LIST_USER]);
      sessionStorage.clear();
      confirm();
    }
  }, [isExpired]);
  useEffect(() => {
    const lastExpireTime: TypeCommon = localStorage.getItem(
      LOCAL_STORAGE_KEY.LAST_EXPIRE_TIME,
    );
    if (lastExpireTime) {
      if (lastExpireTime < Date.now()) {
        setIsExpired(true);
      } else {
        localStorage.removeItem(LOCAL_STORAGE_KEY.LAST_EXPIRE_TIME);
        const interval = setInterval(() => {
          checkForInactivity();
        }, 1000);
        return () => clearInterval(interval);
      }
    } else {
      const interval = setInterval(() => {
        checkForInactivity();
      }, 1000);
      return () => clearInterval(interval);
    }
  }, []);
  useEffect(() => {
    getList();
    if (location !== ROUTERS.SERVICE_MANAGEMENT) getUserDetail();
    const handleResize = (): void => {
      setWindowDimensions(getWindowDimensions());
    };

    window.addEventListener("resize", handleResize);
    window.addEventListener("click", updateExpireTime);
    window.addEventListener("keypress", updateExpireTime);
    window.addEventListener("scroll", updateExpireTime, true);
    window.addEventListener("mousemove", updateExpireTime);
    window.addEventListener("beforeunload", saveExpireTime);
    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("click", updateExpireTime);
      window.removeEventListener("keypress", updateExpireTime);
      window.removeEventListener("scroll", updateExpireTime, true);
      window.removeEventListener("mousemove", updateExpireTime);
      window.removeEventListener("beforeunload", saveExpireTime);
    };
  }, []);

  useEffect(() => {
    if (listOrg?.length > 0) {
      setListOrgs(listOrg);
    }
  }, [listOrg]);

  const handleChangePassword = async (): Promise<void> => {
    try {
      setIsLoading(true);
      const oldPassword = form.getFieldValue("oldPassword").trim();
      const newPassword = form.getFieldValue("newPassword").trim();
      const user = await Auth.currentAuthenticatedUser();
      await Auth.changePassword(user, oldPassword, newPassword);
      setIsLoading(false);
      setIsOpenModalChangePw(false);
      form.resetFields();
      ToastMessage(NOTIFICATION_TYPE.SUCCESS, t("alert-message.success"));
    } catch (err: TypeCommon) {
      setIsLoading(false);
      if (err?.message === CHANGE_PASSWORD_ERROR_TYPE.INCORRECT_PASSWORD) {
        ToastMessage(NOTIFICATION_TYPE.ERROR, "パスワードが間違っています。");
      } else {
        ToastMessage(NOTIFICATION_TYPE.ERROR, t("alert-message.failure"));
      }
    }
  };
  const checkUserExist = async (searchString: string): Promise<TypeCommon> => {
    try {
      if (searchString) {
        const res = await API.get("public", "/check-exist-user", {
          queryStringParameters: {
            search: searchString,
          },
        });
        if (res?.data?.data) {
          setIsEmailExist(true);
          document?.getElementById("email")?.scrollIntoView({
            behavior: "smooth",
            block: "end",
            inline: "nearest",
          });
          return true;
        }
        setIsEmailExist(false);
        return false;
      }
    } catch (error: TypeCommon) {
      return;
    }
  };
  const onUpdateUser = async (): Promise<void> => {
    try {
      setIsLoading(true);
      let isUpdateEmail = false;
      const phoneNumber = formUpdate.getFieldValue("phoneNumber");
      const email = formUpdate.getFieldValue("email");
      const attributes = {
        phone_number: `+81${phoneNumber.slice(1, phoneNumber?.length)}`,
        first_name: formUpdate.getFieldValue("firstName"),
        first_name_yomi: formUpdate.getFieldValue("firstName_yomi"),
        last_name: formUpdate.getFieldValue("lastName"),
        last_name_yomi: formUpdate.getFieldValue("lastName_yomi"),
      };
      if (email !== currentUser?.email) {
        isUpdateEmail = true;
        Object.assign(attributes, {
          email,
        });
        const checkExistEmail = await checkUserExist(email);
        if (!checkExistEmail) {
          await put("user", "/user/update", {
            user_id: currentUser?.sub,
            attributes,
          });
        } else {
          setIsOpenModalPreview(false);
          setIsLoading(false);
          return;
        }
      } else {
        await put("user", "/user/update", {
          user_id: currentUser?.sub,
          attributes,
        });
      }
      localStorage.setItem(
        LOCAL_STORAGE_KEY.USER_INFO,
        JSON.stringify({
          ...userInfo,
          first_name: formUpdate.getFieldValue("firstName"),
          last_name: formUpdate.getFieldValue("lastName"),
          first_name_yomi: formUpdate.getFieldValue("firstName_yomi"),
          last_name_yomi: formUpdate.getFieldValue("lastName_yomi"),
          email,
          phone_number: `+81${phoneNumber.slice(1, phoneNumber?.length)}`,
        }),
      );
      await getUserDetail();
      setIsLoading(false);
      setIsOpenModalPreview(false);
      setIsOpenModalUpdateUser(false);
      if (isUpdateEmail) {
        if (
          userInfo?.group !== USER_GROUP.PLATFORM_ADMIN &&
          userInfo?.group !== USER_GROUP.ADMIN
        ) {
          ToastMessage(
            NOTIFICATION_TYPE.INFO,
            "新しメールアドレスに確認リンクが送信されました。リンクをクリックするとメールアドレスが変更できる。",
          );
        } else
          ToastMessage(
            NOTIFICATION_TYPE.SUCCESS,
            "ユーザー情報を変更しました。",
          );
      } else {
        ToastMessage(NOTIFICATION_TYPE.SUCCESS, "ユーザー情報を変更しました。");
      }
    } catch (err: TypeCommon) {
      setIsLoading(false);
      ToastMessage(NOTIFICATION_TYPE.ERROR, t("alert-message.failure"));
    }
  };

  interface MenuItemType {
    is_active?: boolean;
    serviceid?: number;
    key: string;
    label: string;
    icon?: React.ReactNode;
    path?: string;
    is_release?: boolean;
    disabled?: boolean;
    children?: MenuItemType[];
    type?: string;
    parent?: string;
    is_summit_service?: boolean;
  }

  const [open, setOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const toggleDrawer = (): void => {
    if (isMobile) {
      setMobileOpen(!mobileOpen);
    } else {
      setOpen((prevOpen) => {
        const newOpen = !prevOpen;
        if (!newOpen) {
          setOpenSubMenu([]);
          setAnchorEls({});
        }
        return newOpen;
      });
    }
  };

  const collapsedDrawerWidth = 75;
  const drawerWidth = 250;
  const mobileDrawerWidth = 250;

  // Calculate current drawer width based on device and state
  const getCurrentDrawerWidth = (): number => {
    if (isMobile && mobileOpen) {
      return mobileDrawerWidth;
    }
    if (open) {
      return drawerWidth;
    }
    return collapsedDrawerWidth;
  };

  const currentDrawerWidth = getCurrentDrawerWidth();

  const [openSubMenu, setOpenSubMenu] = useState<string[]>([]);
  const [anchorEls, setAnchorEls] = useState<
    Record<string, HTMLElement | null>
  >({});

  const toggleSubMenu = (
    event: React.MouseEvent<HTMLElement>,
    label: string,
  ): void => {
    event.stopPropagation();
    const target = event.currentTarget;
    setAnchorEls((prev) => ({
      ...prev,
      [label]: prev[label] ? null : target,
    }));
    setOpenSubMenu((prev) => {
      if (prev.includes(label)) {
        return prev.filter((l) => l !== label);
      }
      return [...prev, label];
    });
  };

  const handleClose = (): void => {
    setOpenSubMenu([]);
    setAnchorEls({});
  };

  const handleBrowserConfirm = (
    browserType: string,
    selectedService: TypeCommon,
  ): void => {
    const storeCode = userInfo?.organization_code ?? "000";
    const deviceNum = `iPhone${storeCode}01`;
    const targetUrl = `${selectedService?.path}?cd_tenpo=${storeCode}&device_num=${deviceNum}`;

    if (browserType === "asbrowser") {
      const startTime = Date.now();
      window.location.href = `asbrowser://?url=${targetUrl}`;

      // Kiểm tra sau 300ms nếu không chuyển màn hình
      setTimeout(() => {
        if (Date.now() - startTime < 300) {
          // Nếu không có chuyển hướng (không có handler cho custom scheme)
          ToastMessage(
            NOTIFICATION_TYPE.ERROR,
            "AsBrowserアプリがインストールされていません。",
          );
        }
      }, 200);
    } else if (browserType === "safari") {
      if (isMobileDevice()) {
        window.location.assign(targetUrl);
      } else {
        window.open(targetUrl, "_blank");
      }
    }
  };

  const handleRedirect = async (service: TypeCommon): Promise<void> => {
    if (!service?.path) return;

    if (service?.path.includes("app-nebiki")) {
      Modal.info({
        title: t("button.confirm"),
        content: (
          <div className="flex flex-col gap-4">
            <p>使用するブラウザを選択してください。</p>
            <div className="flex items-center justify-center gap-2">
              <ButtonAntd
                className="!bg-[#1677ff] !text-white hover:opacity-80"
                onClick={(): void => {
                  handleBrowserConfirm("safari", service);
                  Modal.destroyAll();
                }}
                type="primary"
              >
                サファリ
              </ButtonAntd>
              <ButtonAntd
                className="!bg-[#1677ff] !text-white hover:opacity-80"
                onClick={(): void => {
                  handleBrowserConfirm("asbrowser", service);
                  // Modal.destroyAll();
                }}
                type="primary"
              >
                AsBrowser
              </ButtonAntd>
            </div>
          </div>
        ),
        centered: true,
        closable: true,
        footer: null,
        // okText: "キャンセル",
        // onOk: (): void => {
        //   setSelectedService(undefined);
        //   Modal.destroyAll();
        // },
      });
      return;
    }

    const userToken = localStorage.getItem("user_token");
    const refreshToken = localStorage.getItem("refresh_token");
    const idToken = getIdTokenFromLocalStorage();

    if (service?.is_summit_service) {
      if (service?.type === "form" || service?.type === "dashboard") {
        navigate(service?.path);
      } else {
        if (isMobileDevice()) {
          window.location.assign(service?.path);
        } else {
          window.open(service?.path, "_blank");
        }
        if ("Notification" in window) {
          localStorage.setItem(
            LOCAL_STORAGE_KEY.NOTIFICATION_PERMISIION,
            Notification?.permission,
          );
        }
      }
      return;
    }

    if (!service?.is_active) {
      navigate(service?.path);
      return;
    }

    setIsLoading(true);

    try {
      const body = {
        user_token: userToken,
        refresh_token: refreshToken,
        id_token: idToken,
        url: service?.path.startsWith("http")
          ? service?.path
          : `https://${window.location.host}${service?.path}`,
        code_verifier: "",
      };
      const res = await post("auth", "/auth/authorize", body);

      const redirectUrl =
        res?.data?.redirect_url || res?.data?.data?.redirect_url;
      if (redirectUrl) {
        if (isMobileDevice()) {
          window.location.assign(redirectUrl);
        } else {
          window.open(redirectUrl, "_blank");
        }
      }
    } catch (err) {
      ToastMessage(NOTIFICATION_TYPE.ERROR, t("alert-message.failure"));
    } finally {
      setIsLoading(false);
    }
  };

  const renderMenuItems = (
    items: MenuItemType[],
    forceHorizontalLayout = false,
    depth = 0,
    is_popper = true,
  ): TypeCommon => {
    const isChildActive = (children: MenuItemType[] | undefined): boolean => {
      if (!children) return false;
      return children.some((child) => {
        if (child.path && location.startsWith(child.path)) return true;
        if (child.children) return isChildActive(child.children);
        return false;
      });
    };

    const handleDropdownClick = (
      e: React.MouseEvent<HTMLElement>,
      item: MenuItemType,
    ): void => {
      e.preventDefault();
      e.stopPropagation();
      toggleSubMenu(e, item.label);
    };

    const handleMenuItemClick = (
      e: React.MouseEvent<HTMLElement>,
      item: MenuItemType,
    ): void => {
      e.stopPropagation();
      localStorage.setItem("activeMenu", item.path || "");
      if (item.path) {
        handleRedirect(item);
      }
    };

    return (
      <List
        sx={{
          py: 0,
          "& .MuiListItemButton-root": {
            py: 0.5,
            mt: 0.5,
            borderRadius: 3,
            "&:hover": {
              backgroundColor: "rgba(0, 0, 0, 0.04)",
            },
            "&.Mui-selected": {
              backgroundColor: "rgba(25, 118, 210, 0.08)",
              "&:hover": {
                backgroundColor: "rgba(25, 118, 210, 0.12)",
              },
            },
          },
        }}
      >
        {items.map((item) => {
          if (item.disabled) return null;

          const isSubMenuOpen = openSubMenu.includes(item.label);
          const hasChildren = !!item.children;
          const storedActiveMenu = localStorage.getItem("activeMenu");

          let activeFromStored = false;
          if (item.children) {
            item.children.forEach((child) => {
              if (child.path === storedActiveMenu) {
                activeFromStored = true;
              }
            });
          } else if (item.path === storedActiveMenu) {
            activeFromStored = true;
          } else {
            activeFromStored = false;
          }

          const isActive =
            location.startsWith(item.path || "") ||
            isChildActive(item.children) ||
            activeFromStored;
          const isHorizontal = open || isMobile || forceHorizontalLayout;

          const listItem = (
            <ListItemButton
              selected={isActive}
              onClick={(e) => handleMenuItemClick(e, item)}
              sx={{
                display: "flex",
                flexDirection: isHorizontal ? "row" : "column",
                alignItems: "center",
                justifyContent: isHorizontal ? "flex-start" : "center",
                pl: depth > 0 && is_popper ? 1 + depth * 2 : 2,
              }}
            >
              <Box
                sx={{
                  position: "relative",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    justifyContent: "center",
                    mr: isHorizontal ? 2 : 0,
                    mb: isHorizontal ? 0 : 0.5,
                    color: isActive ? "primary.main" : "text.secondary",
                    "& svg": {
                      fontSize: isActive ? "1.5rem" : "1.25rem",
                      transition: "font-size 0.2s ease-in-out",
                    },
                  }}
                >
                  {item.icon}
                </ListItemIcon>

                {!isHorizontal && hasChildren && (
                  <IconButton
                    onClick={(e) => handleDropdownClick(e, item)}
                    sx={{
                      position: "absolute",
                      top: -10,
                      right: -35,
                      color: isActive ? "primary.main" : "text.secondary",
                      "&:hover": {
                        backgroundColor: "rgba(0, 0, 0, 0.04)",
                      },
                    }}
                  >
                    <ArrowRightIcon fontSize="small" />
                  </IconButton>
                )}
              </Box>
              {isHorizontal ? (
                <ListItemText
                  primary={
                    <>
                      {item.is_release === false && (
                        <span className="uat-menu">UAT</span>
                      )}
                      {item.label}
                    </>
                  }
                  sx={{
                    color: isActive ? "primary.main" : "text.primary",
                    fontWeight: 600,
                    "& .MuiTypography-root": {
                      fontSize: "0.875rem",
                      transition: "font-size 0.2s ease-in-out",
                      pl: depth > 0 && is_popper ? 0.5 + depth * 0.5 : 0,
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      fontWeight: 600,
                      "& span": {
                        fontWeight: 600,
                      },
                    },
                  }}
                />
              ) : (
                <Typography
                  variant="caption"
                  textAlign="center"
                  sx={{
                    color: isActive ? "primary.main" : "text.primary",
                    fontWeight: 600,
                    fontSize: "0.55rem",
                    transition: "font-size 0.2s ease-in-out",
                    pl: depth > 0 && is_popper ? 0.5 + depth * 0.5 : 0,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    "& span": {
                      fontWeight: 600,
                    },
                  }}
                >
                  {item.is_release === false && (
                    <span className="uat-menu">UAT</span>
                  )}
                  {item.label}
                </Typography>
              )}
              {hasChildren && isHorizontal && (
                <IconButton
                  onClick={(e) => handleDropdownClick(e, item)}
                  sx={{
                    color: isActive ? "primary.main" : "text.secondary",
                    "&:hover": {
                      backgroundColor: "rgba(0, 0, 0, 0.04)",
                    },
                  }}
                >
                  {isSubMenuOpen ? (
                    <ArrowDropUpIcon fontSize="small" />
                  ) : (
                    <ArrowDropDownIcon fontSize="small" />
                  )}
                </IconButton>
              )}
            </ListItemButton>
          );

          return (
            <Box key={item.label}>
              {listItem}
              {hasChildren &&
                !open &&
                !isMobile &&
                anchorEls[item.label] &&
                depth === 0 && (
                  <Popper
                    sx={{ zIndex: 1000 }}
                    open={isSubMenuOpen}
                    anchorEl={anchorEls[item.label]}
                    placement="right-start"
                    modifiers={[
                      { name: "offset", options: { offset: [0, 4] } },
                    ]}
                  >
                    <ClickAwayListener onClickAway={handleClose}>
                      <Paper
                        elevation={3}
                        sx={{
                          minWidth: 250,
                          maxHeight: "calc(100vh - 200px)",
                          overflowY: "auto",
                          p: 1,
                        }}
                      >
                        {renderMenuItems(
                          item.children!,
                          true,
                          depth + 1,
                          false,
                        )}
                      </Paper>
                    </ClickAwayListener>
                  </Popper>
                )}

              {hasChildren && (open || isMobile || depth > 0) && (
                <Collapse in={isSubMenuOpen} timeout="auto" unmountOnExit>
                  <Box>{renderMenuItems(item.children!, true, depth + 1)}</Box>
                </Collapse>
              )}
            </Box>
          );
        })}
      </List>
    );
  };

  const drawerContent = (
    <Box
      sx={{
        width: currentDrawerWidth,
        pt: "70px",
      }}
    >
      <Box sx={{ px: 1 }}>{renderMenuItems(menuListMui)}</Box>
    </Box>
  );

  const [anchorElUserDropdown, setAnchorEl] = React.useState(null);
  const openUserDropdown = Boolean(anchorElUserDropdown);
  const handleClickUserDropdown = (event: TypeCommon): void => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseUserDropdown = (): void => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (key: string) => () => {
    if (key === "2") {
      confirmLogout();
    } else if (key === "0") {
      setIsOpenModalChangePw(true);
    } else {
      handleClickUpdateInfo();
    }
  };

  return (
    <>
      {(isLoading || isFetchDetail) && <Spinner isFullWidth={true} />}
      {!isMobile &&
        createPortal(
          <IconButton
            onClick={toggleDrawer}
            sx={{
              position: "fixed",
              left: open ? drawerWidth - 15 : collapsedDrawerWidth - 15,
              top: "9%",
              zIndex: 999,
              padding: "3px",
              transform: "translateY(-50%)",
              color: "text.secondary",
              backgroundColor: "background.paper",
              border: "1px solid #e0e0e0",
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.04)",
              },
            }}
          >
            {open ? <ChevronLeftIcon /> : <ChevronRightIcon />}
          </IconButton>,
          document.body,
        )}
      <>
        <CssBaseline />
        <AppBar
          position="fixed"
          sx={{
            height: "60px",
            zIndex: (theme) => theme.zIndex.drawer + 1,
            backgroundColor: "background.paper",
            boxShadow: 1,
          }}
        >
          <Container maxWidth={false} disableGutters sx={{ padding: "0 20px" }}>
            <Toolbar
              disableGutters
              sx={{ minHeight: "60px !important", height: "60px" }}
            >
              <Box
                component="img"
                src={logo}
                sx={{
                  width: { xs: 35, sm: 35, md: 50 },
                  height: { xs: 35, sm: 35, md: 50 },
                  cursor: "pointer",
                }}
                onClick={(): void => {
                  window.location.reload();
                }}
              />
              <Typography
                variant="h4"
                gutterBottom
                sx={{
                  ml: 1,
                  margin: "0px 0px 0px 8px",
                  fontSize: "1rem",
                  color: "rgb(18, 25, 38)",
                  fontWeight: 600,
                  lineHeight: 1.235,
                  display: { xs: "none", md: "flex" },
                }}
              >
                サミットアシスト
              </Typography>
              {isMobile && (
                <IconButton
                  aria-label="open drawer"
                  edge="start"
                  onClick={toggleDrawer}
                  sx={{ ml: 1 }}
                >
                  <MenuIcon />
                </IconButton>
              )}
              <Box
                sx={{
                  flexGrow: 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <Button variant="text" onClick={confirmLogout}>
                  ユーザー切替
                </Button>
                <IconButton
                  onClick={handleClickUserDropdown}
                  size="small"
                  disableRipple
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    backgroundColor: "transparent",
                    "&:hover": {
                      backgroundColor: "transparent",
                      opacity: 0.8,
                    },
                  }}
                >
                  <Avatar
                    sx={{
                      bgcolor: "#79AF7C",
                      width: 32,
                      height: 32,
                      fontSize: 14,
                      fontWeight: 600,
                      textTransform: "uppercase",
                    }}
                  >
                    {userInfo?.username?.slice(0, 2)}
                  </Avatar>
                  <Typography
                    sx={{
                      display: { xs: "none", md: "block" },
                      fontSize: 14,
                      fontWeight: 500,
                      maxWidth: 150,
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {userInfo?.username}
                  </Typography>
                </IconButton>
              </Box>
              <Menu
                anchorEl={anchorElUserDropdown}
                id="account-menu"
                open={openUserDropdown}
                onClose={handleCloseUserDropdown}
                onClick={handleCloseUserDropdown}
                slotProps={{
                  paper: {
                    elevation: 0,
                    sx: {
                      overflow: "visible",
                      filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                      mt: 1.5,
                      "& .MuiAvatar-root": {
                        width: 32,
                        height: 32,
                        ml: -0.5,
                        mr: 1,
                      },
                      "&::before": {
                        content: '""',
                        display: "block",
                        position: "absolute",
                        top: 0,
                        right: 14,
                        width: 10,
                        height: 10,
                        bgcolor: "background.paper",
                        transform: "translateY(-50%) rotate(45deg)",
                        zIndex: 0,
                      },
                    },
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <MenuItem onClick={handleMenuItemClick("4")}>
                  ユーザー管理
                </MenuItem>
              </Menu>
            </Toolbar>
          </Container>
        </AppBar>

        <Box
          sx={{
            display: "flex",
            height: "calc(100vh - 60px)",
            mt: "60px",
          }}
        >
          <Drawer
            variant={isMobile ? "temporary" : "permanent"}
            open={isMobile ? mobileOpen : true}
            onClose={isMobile ? toggleDrawer : undefined}
            ModalProps={{ keepMounted: true }}
            sx={{
              width: currentDrawerWidth,
              flexShrink: 0,
              [`& .MuiDrawer-paper`]: {
                width: currentDrawerWidth,
                boxSizing: "border-box",
                transition: "width 0.3s",
                overflowX: "hidden",
                borderRight: "1px solid #e0e0e0",
                backgroundColor: "background.paper",
              },
            }}
          >
            {drawerContent}
          </Drawer>

          <Box
            component="main"
            sx={{
              flexGrow: 1,
              overflowY: "auto",
              backgroundColor: "background.default",
              p: { xs: "12px", sm: "16px", md: "20px" },
            }}
          >
            <Outlet context={[serviceIds, isFetchDetail]} />
          </Box>
        </Box>
      </>
      {isOpenModalChangePw && (
        <ModalChangePassword
          form={form}
          open={isOpenModalChangePw}
          handleCancel={(): void => {
            form.resetFields();
            setIsOpenModalChangePw(false);
          }}
          handleConfirm={handleChangePassword}
        />
      )}
      {isOpenModalUpdateUser && (
        <Modal
          title={`ユーザー管理`}
          centered
          maskClosable={false}
          open={isOpenModalUpdateUser}
          onCancel={(): void => {
            setIsOpenModalUpdateUser(false);
            setIsEmailExist(false);
          }}
          onOk={(): void => formUpdate.submit()}
          className="modal-update-info modal-custom"
          cancelText={t("button.cancel")}
          okText={t("button.next")}
        >
          <SimpleBar
            style={{
              height:
                windowDimensions?.height > 800
                  ? "500px"
                  : windowDimensions?.height - 200,
              width: "100%",
              padding: "0 24px",
            }}
          >
            <FormRegister
              form={formUpdate}
              userData={currentUser}
              onSubmit={(): void => {
                formPreview.setFieldsValue({
                  firstName: formUpdate.getFieldValue("firstName"),
                  lastName: formUpdate.getFieldValue("lastName"),
                  firstName_yomi: formUpdate.getFieldValue("firstName_yomi"),
                  lastName_yomi: formUpdate.getFieldValue("lastName_yomi"),
                  userName: formUpdate.getFieldValue("userName"),
                  email: formUpdate.getFieldValue("email"),
                  phoneNumber: formUpdate.getFieldValue("phoneNumber"),
                  role: formUpdate.getFieldValue("role"),
                  org: formUpdate.getFieldValue("org"),
                });
                setIsOpenModalPreview(true);
              }}
              formType={FORM_TYPE.USER_UPDATE}
              isEmailExist={isEmailExist}
              setIsEmailExist={setIsEmailExist}
              listAllOrg={listOrgs}
            />
          </SimpleBar>
        </Modal>
      )}
      {isOpenModalPreview && (
        <Modal
          title={`ユーザー管理`}
          centered
          maskClosable={false}
          open={isOpenModalPreview}
          onCancel={(): void => {
            setIsOpenModalPreview(false);
          }}
          onOk={(): void => formPreview.submit()}
          className="modal-update-info modal-custom"
          cancelText={t("button.cancel")}
          okText={"更新"}
        >
          <SimpleBar
            style={{
              height:
                windowDimensions?.height > 800
                  ? "500px"
                  : windowDimensions?.height - 200,
              width: "100%",
              padding: "0 24px",
            }}
          >
            <FormRegister
              form={formPreview}
              isPreview
              onSubmit={onUpdateUser}
              listAllOrg={listOrgs}
            />
          </SimpleBar>
        </Modal>
      )}
    </>
  );
};

export default MainLayout;
